export class ConfigService {
  BRANCH_DIRECT_URL: string;
  BRANCH_WALLET_URL: string;
  FACEBOOK_APP_ID: string;
  GOOGLE_APP_ID: string;
  SERVER_URL: string;
  STRIPE_KEY: string;
  RECAPTCHA_KEY: string

  constructor() {
    this.BRANCH_DIRECT_URL = process.env.REACT_APP_BRANCH_DIRECT_URL ?? '';
    this.BRANCH_WALLET_URL = process.env.REACT_APP_BRANCH_WALLET_URL ?? '';
    this.FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID ?? '';
    this.GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID ?? '';
    this.SERVER_URL = process.env.REACT_APP_SERVER_URL ?? '';
    this.STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY ?? '';
    this.RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY ?? '';
  }
}
